var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1114 0.438965C4.52686 0.438965 0 5.1671 0 10.9999C0 16.8327 4.52686 21.5608 10.1114 21.5608C15.6959 21.5608 20.2227 16.8327 20.2227 10.9999C20.2227 5.1671 15.6959 0.438965 10.1114 0.438965ZM10.1114 16.2804C9.55321 16.2804 9.10022 15.8072 9.10022 15.2243V10.9999C9.10022 10.4169 9.55321 9.94381 10.1114 9.94381C10.6695 9.94381 11.1225 10.4169 11.1225 10.9999V15.2243C11.1225 15.8072 10.6695 16.2804 10.1114 16.2804ZM10.6169 7.83162H9.60579C9.32672 7.83162 9.10022 7.59505 9.10022 7.30357V6.24748C9.10022 5.956 9.32672 5.71943 9.60579 5.71943H10.6169C10.896 5.71943 11.1225 5.956 11.1225 6.24748V7.30357C11.1225 7.59505 10.896 7.83162 10.6169 7.83162Z",
    fill: "#FAF3C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconYellow);
export default __webpack_public_path__ + "static/media/info_icon_yellow.8ea5d60c893694ffe70c40e6424f9f70.svg";
export { ForwardRef as ReactComponent };